module.exports = __webpack_public_path__ + "static/img/sort-back3.3e40ad30.png";